<template>
  <div>
    <div v-for="(question, questionKey) in questions" :key="questionKey">
      <DeterminationSetting
        :answer="getAnswer(questionKey)"
        :question-key="questionKey"
        :question="question"
        :question-key-prefix="questionCollectionKey"
        :read-only="readOnly"
        @changed="updateAnswer"
      >
        <template v-if="getSuggestedAnswer(questionKey)" #notice>
          <slot name="suggested-answer" :answer="getSuggestedAnswer(questionKey)" />
        </template>
      </DeterminationSetting>
    </div>

    <WdsButton
      v-if="hasSuggestedAnswers"
      type="button"
      primary
      sm
      class="m-t-10 m-b-20"
      @click="syncAnswers"
    >
      Adjust your answers to match freelancer suggestions
    </WdsButton>

    <input
      :name="`${questionCollectionPrefix}${questionCollectionKey}`"
      :value="answersToPostJson"
      type="hidden"
    />
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { WdsButton } from '@worksome/wds-components'
import { isObject } from '@/utils/tools'
import DeterminationSetting from '@/components/DeterminationSetting.vue'

export default {
  name: 'DeterminationSettings',
  components: {
    WdsButton,
    DeterminationSetting,
  },
  props: {
    questions: { type: Object, required: true },
    answers: {
      required: true,
      validator: (value) => value === null || isObject(value),
    },
    suggestedAnswers: { type: Object, default: () => ({}) },
    questionCollectionKey: { type: String, default: 'answers' },
    readOnly: { type: Boolean, default: false },
    questionCollectionPrefix: {
      type: String,
      default: 'determination_',
    },
  },
  setup(props, { emit }) {
    const answers = ref(props.answers || {})
    const answersToPost = ref({})
    const answersToPostJson = ref(null)
    const suggestedAnswers = ref(props.suggestedAnswers || {})

    const getSuggestedAnswer = (questionKey) =>
      Object.keys(suggestedAnswers.value).indexOf(questionKey) >= 0
        ? suggestedAnswers.value[questionKey]
        : null

    const getAnswer = (questionKey) =>
      Object.keys(answers.value).indexOf(questionKey) >= 0 ? answers.value[questionKey] : undefined

    const setPostAnswers = () => {
      Object.keys(props.questions).forEach((key) => {
        if (getAnswer(key)) {
          answersToPost.value[key] = getAnswer(key)
        }
      })
    }

    const isAllAnswered = computed(
      () => Object.keys(answersToPost.value).length === Object.keys(props.questions).length,
    )

    const updateAnswer = (answer) => {
      answers.value[answer.questionKey] = answer.answer
      answersToPost.value[answer.questionKey] = answer.answer
      answersToPostJson.value = JSON.stringify(answersToPost.value)
      emit('all-answered', isAllAnswered.value)
    }

    setPostAnswers()

    onMounted(() => {
      emit('all-answered', isAllAnswered.value)
    })

    return {
      answersToPostJson,
      getAnswer,
      hasSuggestedAnswers: computed(
        () =>
          Object.keys(props.questions).filter((questionKey) =>
            Object.keys(suggestedAnswers.value).includes(questionKey),
          ).length > 0,
      ),
      getSuggestedAnswer,
      updateAnswer,
      syncAnswers: () => {
        if (Object.keys(suggestedAnswers.value).length === 0) return

        Object.keys(suggestedAnswers.value).forEach((key) =>
          updateAnswer({
            questionKey: key,
            answer: suggestedAnswers.value[key],
          }),
        )
      },
    }
  },
}
</script>
